import { render } from "./InputComponent.vue?vue&type=template&id=15db9520&scoped=true"
import script from "./InputComponent.vue?vue&type=script&lang=js"
export * from "./InputComponent.vue?vue&type=script&lang=js"

import "./InputComponent.vue?vue&type=style&index=0&id=15db9520&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15db9520"]])

export default __exports__